import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import PresentationLayout from './layouts/Presentation';
import { PublicLayout } from './layouts/Public';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/chats" />,
  },
  {
    path: '/public',
    component: PublicLayout,
    routes: [
      {
        path: '/public/initialize-rcs/thank-you',
        exact: true,
        component: lazy(() => import('./containers/views/RCS/Thanks')),
      },
      {
        path: '/public/initialize-rcs/:channelID',
        exact: true,
        component: lazy(() => import('./containers/views/RCS/Init')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/qr',
    component: PresentationLayout,
    routes: [
      {
        path: '/qr',
        exact: true,
        component: lazy(() => import('./containers/views/QR')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('./containers/views/Login')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('./containers/views/Errors/Error401')),
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('./containers/views/Errors/Error404')),
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('./containers/views/Errors/Error500')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/channels',
        exact: true,
        component: lazy(() => import('./containers/views/Channels')),
      },
      {
        path: '/chats',
        exact: true,
        component: lazy(() => import('./containers/views/Chat')),
      },
      {
        path: '/chats/:id',
        exact: true,
        component: lazy(() => import('./containers/views/Chat')),
      },
      {
        path: '/customers',
        exact: true,
        component: lazy(() => import('./containers/views/Customers')),
      },
      {
        path: '/pricing',
        exact: true,
        component: lazy(() => import('./containers/views/Pricing')),
      },
      {
        path: '/chatbot',
        exact: true,
        component: lazy(() => import('./containers/views/ChatBot')),
      },
      {
        path: '/settings',
        exact: true,
        component: lazy(() => import('./containers/views/Settings')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
];
